export class SipDashletStorage {
  private storage: Record<string, SipDashletItem> = {};

  public addDashletItem(id: string, dashletItem: SipDashletItem) {
    return (this.storage[id] = dashletItem);
  }

  public getAllDashletItems(): Record<string, SipDashletItem> {
    return this.storage;
  }
}

export interface SipDashletItem {
  id: string;
  app: string;
  title: string;
  description: string;
  params: object;
}
